import { EduButton } from '@edulastic/common'
import { Modal } from 'antd'
import { upperFirst } from 'lodash'
import React, { useEffect } from 'react'
import { ActionContainer, ModalMessage, Heading } from './styled'

const ResendVerificationEmailPopup = ({
  visible,
  onCancel,
  onOk,
  provider = '',
  title = 'Resend Verification',
  closable = false,
}) => {
  useEffect(() => {
    // to make the modal accessible we need to set the aria-describedby and aria-modal attributes
    const timer = setTimeout(() => {
      const modalNode = document.querySelector('.ant-modal-wrap')
      if (modalNode) {
        modalNode.setAttribute('aria-describedby', 'reverify-modal-message')
        modalNode.setAttribute('aria-modal', 'true')
      }
    }, 0)
    return () => clearTimeout(timer)
  }, [visible])
  return (
    <Modal
      title={<Heading data-cy="emailPromptTitle">{title}</Heading>}
      visible={visible}
      onCancel={onCancel}
      onOk={onOk}
      footer={null}
      closable={closable}
    >
      <ModalMessage id="reverify-modal-message" data-cy="emailPromptMsg">
        We found an existing account for this email. To continue linking{' '}
        {upperFirst(provider)}, please reverify your email.
      </ModalMessage>
      <ActionContainer>
        <EduButton
          type="primary"
          onClick={onOk}
          aria-label={`Resend verification email for ${provider} account`}
          data-cy="resendVerificationButton"
        >
          Resend Verification
        </EduButton>
      </ActionContainer>
    </Modal>
  )
}

export default ResendVerificationEmailPopup
